import { useParams } from 'react-router-dom';
import { TeachingBlockVersionLessonsTable } from '../../../../../../components/Lessons/Tables/TeachingBlockVersionLessonsTable';

export const PlanTeachingBlockLessons = () => {
  const { teachingBlockVersionUuid } = useParams();

  return <TeachingBlockVersionLessonsTable versionUuid={teachingBlockVersionUuid ?? ''} />;
};
